/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './date-and-product-select-dialog.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/flex-layout/flexbox/api/layout';
import * as i5 from '@angular/flex-layout/media-query/media-monitor';
import * as i6 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i7 from '@angular/flex-layout/flexbox/api/layout-align';
import * as i8 from '@angular/forms';
import * as i9 from '../../../../../app/shared/dialogs/date-and-product-select-dialog/date-and-product-select-dialog.component';
import * as i10 from '@angular/common';
import * as i11 from '@angular/platform-browser';
import * as i12 from '@angular/flex-layout/flexbox/api/flex';
import * as i13 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i14 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i15 from '@angular/flex-layout/flexbox/api/class';
import * as i16 from '../../../../../app/shared/services/authentication.service';
import * as i17 from '../../../../../app/agatextscreens/purchasing/products/product.service';
import * as i18 from '../../../../../app/agatextscreens/accounting/branches/branch.service';
const styles_DateAndProductSelectDialogComponent:any[] = [i0.styles];
export const RenderType_DateAndProductSelectDialogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DateAndProductSelectDialogComponent,data:{}});
function View_DateAndProductSelectDialogComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[7,4]],0,i3.MdOption,[i1.ElementRef,[2,i3.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['',' -\n        ',
          '']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.code;
    const currVal_11:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_DateAndProductSelectDialogComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    if (('click' === en)) {
      const pd_2:any = ((<any>_co.setSelected(_v.context.$implicit)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[14,4]],0,i3.MdOption,[i1.ElementRef,[2,i3.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['\n        ','\n      ']))],
      (_ck,_v) => {
        const currVal_9:any = ((((((_v.context.$implicit == null)? (null as any): _v.context.$implicit.collection_name) + ' - ') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.design_name)) + '/') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.name));
        _ck(_v,2,0,currVal_9);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
        const currVal_1:any = i1.ɵnov(_v,2).selected;
        const currVal_2:any = i1.ɵnov(_v,2).multiple;
        const currVal_3:any = i1.ɵnov(_v,2).active;
        const currVal_4:any = i1.ɵnov(_v,2).id;
        const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
        const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
        const currVal_7:any = i1.ɵnov(_v,2).disabled;
        const currVal_8:any = true;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7,currVal_8);
        const currVal_10:any = ((((((_v.context.$implicit == null)? (null as any): _v.context.$implicit.collection_name) + ' - ') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.design_name)) + '/') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.name));
        _ck(_v,3,0,currVal_10);
      });
}
export function View_DateAndProductSelectDialogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),96,'div',[['fxLayout',
      'column'],['style','min-width: 500px;']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,
      [i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'h4',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['Select Branch and From Date'])),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          35,'div',[['fxLayout','row'],['fxLayoutAlign','center center'],['fxLayoutGap',
              '30px']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),
          0,i6.LayoutGapDirective,[i5.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i4.LayoutDirective]],
          {gap:[0,'gap']},(null as any)),i1.ɵdid(737280,(null as any),0,i7.LayoutAlignDirective,
          [i5.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i4.LayoutDirective]],{align:[0,
              'align']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),16,'md-input-container',[['flex',
          '']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,12)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      (_l()(),i1.ɵted(1,['\n      '])),(_l()(),i1.ɵeld(0,(null as any),1,6,'input',
          [['mdInput',''],['placeholder','Date From'],['type','date']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.DateAndProductSelectDialogComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,21)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,21).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,21)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,21)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,26)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,26)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,26)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.from = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[1,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder'],
              type:[1,'type']},(null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          11,'md-select',[['flex',''],['name','branch'],['placeholder','Branch'],['role',
              'listbox'],['style','padding-top: 1px;']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,
                  'aria-labelledby',0],[1,'aria-required',0],[1,'aria-disabled',0],
              [1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],
              [2,'mat-select',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'keydown'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.DateAndProductSelectDialogComponent = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,34)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,34)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.selectedBranch = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i2.View_MdSelect_0,i2.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),
          0,i8.NgControlStatus,[i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i3.MdSelect,[i1.ElementRef,i1.Renderer2,i3.ViewportRuler,i1.ChangeDetectorRef,
              [2,i3.Dir],[2,i8.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,7,{options:1}),(_l()(),i1.ɵted(0,['\n      '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,2,(null as any),View_DateAndProductSelectDialogComponent_1)),
      i1.ɵdid(802816,(null as any),0,i10.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i10.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),['\n\n  '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h4',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['Product ',' ','\n    ','',' ','\n    ','','',''])),(_l()(),i1.ɵted((null as any),
          ['\n\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),26,'md-input-container',
          ([] as any[]),[[1,'align',0],[2,'mat-input-container',(null as any)],[2,
              'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],[2,
              'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,47)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,8,{_mdInputChild:0}),i1.ɵqud(335544320,9,{_placeholderChild:0}),
      i1.ɵqud(603979776,10,{_errorChildren:1}),i1.ɵqud(603979776,11,{_hintChildren:1}),
      i1.ɵqud(603979776,12,{_prefixChildren:1}),i1.ɵqud(603979776,13,{_suffixChildren:1}),
      (_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),1,7,'input',
          [['aria-autocomplete','list'],['aria-multiline','false'],['autocomplete',
              'off'],['flex',''],['mdInput',''],['placeholder','Collection - Design/Color'],
              ['role','combobox']],[[1,'aria-activedescendant',0],[1,'aria-expanded',
              0],[1,'aria-owns',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[2,'mat-input-element',(null as any)],[8,'id',0],
              [8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',
                  0]],[[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'focus'],[(null as any),'keydown']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.DateAndProductSelectDialogComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,56)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,56).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,56)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,56)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,57).openPanel()) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,57)._handleInput($event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,57)._onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('keydown' === en)) {
              const pd_7:any = ((<any>i1.ɵnov(_v,57)._handleKeydown($event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('blur' === en)) {
              const pd_8:any = ((<any>i1.ɵnov(_v,62)._onBlur()) !== false);
              ad = (pd_8 && ad);
            }
            if (('focus' === en)) {
              const pd_9:any = ((<any>i1.ɵnov(_v,62)._onFocus()) !== false);
              ad = (pd_9 && ad);
            }
            if (('input' === en)) {
              const pd_10:any = ((<any>i1.ɵnov(_v,62)._onInput()) !== false);
              ad = (pd_10 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_11:any = ((<any>(_co.prod = $event)) !== false);
              ad = (pd_11 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_12:any = ((<any>_co.filterProducts(_co.prod)) !== false);
              ad = (pd_12 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(147456,(null as any),0,i3.MdAutocompleteTrigger,[i1.ElementRef,
          i3.Overlay,i1.ViewContainerRef,i1.ChangeDetectorRef,i3.ScrollDispatcher,
          [2,i3.Dir],i1.NgZone,[2,i3.MdInputContainer],[2,i11.DOCUMENT]],{autocomplete:[0,
          'autocomplete']},(null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i8.DefaultValueAccessor,i3.MdAutocompleteTrigger]),i1.ɵdid(671744,(null as any),
          0,i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[8,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(0,(null as any),
          1,7,'md-autocomplete',([] as any[]),[[2,'mat-autocomplete',(null as any)]],
          (null as any),(null as any),i2.View_MdAutocomplete_0,i2.RenderType_MdAutocomplete)),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1097728,[['autoColor',
          4]],1,i3.MdAutocomplete,[i1.ChangeDetectorRef],(null as any),(null as any)),
      i1.ɵqud(603979776,14,{options:1}),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_DateAndProductSelectDialogComponent_2)),
      i1.ɵdid(802816,(null as any),0,i10.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n    '])),(_l()(),i1.ɵted(1,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),21,'div',[['class',
          'table-control-buttons'],['fxFlex',''],['fxFlexAlign','start center'],['fxFlexAlign.lt-md',
          'center'],['fxLayout','row']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,
          [i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      i1.ɵdid(737280,(null as any),0,i12.FlexDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i4.LayoutDirective],[3,i13.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i14.FlexAlignDirective,
          [i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i15.ClassDirective,
          [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',[['class',
          'bg-blue color-white mat-button'],['color','primary'],['md-button','']],
          [[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.DateAndProductSelectDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.close({from:_co.from,colorId:((_co.selectedProduct == null)? (null as any): _co.selectedProduct.id),
                  branchId:_co.selectedBranch,fullName:((((((_co.selectedProduct == null)? (null as any): _co.selectedProduct.collection_name) + ' - ') + ((_co.selectedProduct == null)? (null as any): _co.selectedProduct.design_name)) + '/') + ((_co.selectedProduct == null)? (null as any): _co.selectedProduct.name))})) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i15.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['Accept'])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'div',[['flex',
          '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          5,'button',[['class','bg-red color-white mat-button'],['color','warn'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.DateAndProductSelectDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.close((null as any))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i15.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['Cancel'])),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵted((null as any),['\n\n\n\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i9.DateAndProductSelectDialogComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'row';
    _ck(_v,7,0,currVal_1);
    const currVal_2:any = '30px';
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = 'center center';
    _ck(_v,9,0,currVal_3);
    const currVal_28:any = _co.from;
    _ck(_v,23,0,currVal_28);
    const currVal_29:any = 'Date From';
    const currVal_30:any = 'date';
    _ck(_v,26,0,currVal_29,currVal_30);
    const currVal_47:any = 'branch';
    const currVal_48:any = _co.selectedBranch;
    _ck(_v,30,0,currVal_47,currVal_48);
    const currVal_49:any = 'Branch';
    _ck(_v,34,0,currVal_49);
    const currVal_50:any = i1.ɵunv(_v,38,0,i1.ɵnov(_v,39).transform(_co.allBranches$));
    _ck(_v,38,0,currVal_50);
    const currVal_86:any = i1.ɵnov(_v,66);
    _ck(_v,57,0,currVal_86);
    const currVal_87:any = _co.prod;
    _ck(_v,59,0,currVal_87);
    const currVal_88:any = 'Collection - Design/Color';
    _ck(_v,62,0,currVal_88);
    const currVal_90:any = _co.matchingProducts;
    _ck(_v,70,0,currVal_90);
    const currVal_91:any = 'row';
    _ck(_v,75,0,currVal_91);
    const currVal_92:any = '';
    _ck(_v,76,0,currVal_92);
    const currVal_93:any = 'start center';
    const currVal_94:any = 'center';
    _ck(_v,77,0,currVal_93,currVal_94);
    const currVal_95:any = 'table-control-buttons';
    _ck(_v,78,0,currVal_95);
    const currVal_97:any = 'primary';
    _ck(_v,82,0,currVal_97);
    const currVal_98:any = 'bg-blue color-white';
    _ck(_v,84,0,currVal_98);
    const currVal_100:any = 'warn';
    _ck(_v,91,0,currVal_100);
    const currVal_101:any = 'bg-red color-white';
    _ck(_v,93,0,currVal_101);
  },(_ck,_v) => {
    var _co:i9.DateAndProductSelectDialogComponent = _v.component;
    const currVal_4:any = (null as any);
    const currVal_5:any = true;
    const currVal_6:any = i1.ɵnov(_v,12)._isErrorState();
    const currVal_7:any = i1.ɵnov(_v,12)._mdInputChild.focused;
    const currVal_8:any = i1.ɵnov(_v,12)._shouldForward('untouched');
    const currVal_9:any = i1.ɵnov(_v,12)._shouldForward('touched');
    const currVal_10:any = i1.ɵnov(_v,12)._shouldForward('pristine');
    const currVal_11:any = i1.ɵnov(_v,12)._shouldForward('dirty');
    const currVal_12:any = i1.ɵnov(_v,12)._shouldForward('valid');
    const currVal_13:any = i1.ɵnov(_v,12)._shouldForward('invalid');
    const currVal_14:any = i1.ɵnov(_v,12)._shouldForward('pending');
    _ck(_v,11,1,[currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,
        currVal_11,currVal_12,currVal_13,currVal_14]);
    const currVal_15:any = i1.ɵnov(_v,25).ngClassUntouched;
    const currVal_16:any = i1.ɵnov(_v,25).ngClassTouched;
    const currVal_17:any = i1.ɵnov(_v,25).ngClassPristine;
    const currVal_18:any = i1.ɵnov(_v,25).ngClassDirty;
    const currVal_19:any = i1.ɵnov(_v,25).ngClassValid;
    const currVal_20:any = i1.ɵnov(_v,25).ngClassInvalid;
    const currVal_21:any = i1.ɵnov(_v,25).ngClassPending;
    const currVal_22:any = true;
    const currVal_23:any = i1.ɵnov(_v,26).id;
    const currVal_24:any = i1.ɵnov(_v,26).placeholder;
    const currVal_25:any = i1.ɵnov(_v,26).disabled;
    const currVal_26:any = i1.ɵnov(_v,26).required;
    const currVal_27:any = (i1.ɵnov(_v,26).ariaDescribedby || (null as any));
    _ck(_v,20,1,[currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,
        currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27]);
    const currVal_31:any = i1.ɵnov(_v,32).ngClassUntouched;
    const currVal_32:any = i1.ɵnov(_v,32).ngClassTouched;
    const currVal_33:any = i1.ɵnov(_v,32).ngClassPristine;
    const currVal_34:any = i1.ɵnov(_v,32).ngClassDirty;
    const currVal_35:any = i1.ɵnov(_v,32).ngClassValid;
    const currVal_36:any = i1.ɵnov(_v,32).ngClassInvalid;
    const currVal_37:any = i1.ɵnov(_v,32).ngClassPending;
    const currVal_38:any = i1.ɵnov(_v,34).tabIndex;
    const currVal_39:any = i1.ɵnov(_v,34)._ariaLabel;
    const currVal_40:any = i1.ɵnov(_v,34).ariaLabelledby;
    const currVal_41:any = i1.ɵnov(_v,34).required.toString();
    const currVal_42:any = i1.ɵnov(_v,34).disabled.toString();
    const currVal_43:any = (((i1.ɵnov(_v,34)._control == null)? (null as any): i1.ɵnov(_v,
        34)._control.invalid) || 'false');
    const currVal_44:any = i1.ɵnov(_v,34)._optionIds;
    const currVal_45:any = i1.ɵnov(_v,34).disabled;
    const currVal_46:any = true;
    _ck(_v,29,1,[currVal_31,currVal_32,currVal_33,currVal_34,currVal_35,currVal_36,
        currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,
        currVal_44,currVal_45,currVal_46]);
    const currVal_51:any = ((_co.selectedProduct == null)? (null as any): _co.selectedProduct.collection_name);
    const currVal_52:any = (_co.selectedProduct? ' - ': '');
    const currVal_53:any = ((_co.selectedProduct == null)? (null as any): _co.selectedProduct.design_name);
    const currVal_54:any = (_co.selectedProduct? '/': '');
    const currVal_55:any = ((_co.selectedProduct == null)? (null as any): _co.selectedProduct.name);
    const currVal_56:any = (_co.selectedProduct? '(': '');
    const currVal_57:any = ((_co.selectedProduct == null)? (null as any): _co.selectedProduct.id);
    const currVal_58:any = (_co.selectedProduct? ')': '');
    _ck(_v,44,0,currVal_51,currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,
        currVal_57,currVal_58);
    const currVal_59:any = (null as any);
    const currVal_60:any = true;
    const currVal_61:any = i1.ɵnov(_v,47)._isErrorState();
    const currVal_62:any = i1.ɵnov(_v,47)._mdInputChild.focused;
    const currVal_63:any = i1.ɵnov(_v,47)._shouldForward('untouched');
    const currVal_64:any = i1.ɵnov(_v,47)._shouldForward('touched');
    const currVal_65:any = i1.ɵnov(_v,47)._shouldForward('pristine');
    const currVal_66:any = i1.ɵnov(_v,47)._shouldForward('dirty');
    const currVal_67:any = i1.ɵnov(_v,47)._shouldForward('valid');
    const currVal_68:any = i1.ɵnov(_v,47)._shouldForward('invalid');
    const currVal_69:any = i1.ɵnov(_v,47)._shouldForward('pending');
    _ck(_v,46,1,[currVal_59,currVal_60,currVal_61,currVal_62,currVal_63,currVal_64,
        currVal_65,currVal_66,currVal_67,currVal_68,currVal_69]);
    const currVal_70:any = ((i1.ɵnov(_v,57).activeOption == null)? (null as any): i1.ɵnov(_v,
        57).activeOption.id);
    const currVal_71:any = i1.ɵnov(_v,57).panelOpen.toString();
    const currVal_72:any = ((i1.ɵnov(_v,57).autocomplete == null)? (null as any): i1.ɵnov(_v,
        57).autocomplete.id);
    const currVal_73:any = i1.ɵnov(_v,61).ngClassUntouched;
    const currVal_74:any = i1.ɵnov(_v,61).ngClassTouched;
    const currVal_75:any = i1.ɵnov(_v,61).ngClassPristine;
    const currVal_76:any = i1.ɵnov(_v,61).ngClassDirty;
    const currVal_77:any = i1.ɵnov(_v,61).ngClassValid;
    const currVal_78:any = i1.ɵnov(_v,61).ngClassInvalid;
    const currVal_79:any = i1.ɵnov(_v,61).ngClassPending;
    const currVal_80:any = true;
    const currVal_81:any = i1.ɵnov(_v,62).id;
    const currVal_82:any = i1.ɵnov(_v,62).placeholder;
    const currVal_83:any = i1.ɵnov(_v,62).disabled;
    const currVal_84:any = i1.ɵnov(_v,62).required;
    const currVal_85:any = (i1.ɵnov(_v,62).ariaDescribedby || (null as any));
    _ck(_v,55,1,[currVal_70,currVal_71,currVal_72,currVal_73,currVal_74,currVal_75,
        currVal_76,currVal_77,currVal_78,currVal_79,currVal_80,currVal_81,currVal_82,
        currVal_83,currVal_84,currVal_85]);
    const currVal_89:any = true;
    _ck(_v,64,0,currVal_89);
    const currVal_96:any = (i1.ɵnov(_v,82).disabled || (null as any));
    _ck(_v,80,0,currVal_96);
    const currVal_99:any = (i1.ɵnov(_v,91).disabled || (null as any));
    _ck(_v,89,0,currVal_99);
  });
}
export function View_DateAndProductSelectDialogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-date-and-product-select-dialog',
      ([] as any[]),(null as any),(null as any),(null as any),View_DateAndProductSelectDialogComponent_0,
      RenderType_DateAndProductSelectDialogComponent)),i1.ɵdid(245760,(null as any),
      0,i9.DateAndProductSelectDialogComponent,[i16.AuthenticationService,i17.ProductService,
          i3.MdDialogRef,i18.BranchService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const DateAndProductSelectDialogComponentNgFactory:i1.ComponentFactory<i9.DateAndProductSelectDialogComponent> = i1.ɵccf('app-date-and-product-select-dialog',
    i9.DateAndProductSelectDialogComponent,View_DateAndProductSelectDialogComponent_Host_0,
    {},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/shared/dialogs/date-and-product-select-dialog/date-and-product-select-dialog.component.ngfactory.ts